/**
 * Feature flags for new themes and palettes.
 *
 * Set a flag to `true` to enable the corresponding palette or theme in the UI.
 * Items with `enabled: false` in jdm-themes.json are ALSO gated by these flags —
 * both the JSON flag AND the code flag must be true for an item to appear.
 *
 * Flip each flag to `true` once the palette/theme has been visually verified
 * and is ready for public use.
 */
export const FEATURE_FLAGS = {
  // ── New standalone graph palettes ──────────────────────────────────────
  palette_betaDark:      true,
  palette_betaLight:     true,

  // ── Full UI themes (CSS variable overrides + auto-linked palette) ─────
  theme_oldGlory:        true,
  theme_sakura:          true,
  theme_harvest:         true,
  theme_trickOrTreat:    true,
  theme_yuletide:        true,
};
